;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$log", "$timeout", "glDialog", "facesService", "userService", "glPrefs", "glAnalytics", "surveysService"];
  angular.module('core.faces').controller('Faces', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $log,
    $timeout,
    glDialog,
    facesService,
    userService,
    glPrefs,
    glAnalytics,
    surveysService
  ) {
    var log = $log.create('Faces')
    var prefs = glPrefs.create('faces')
    var pushedKey = 'fbfg-' + $scope.element.id
    var timer
    var POPBACK_TIME_SECONDS = 6

    $scope.faces = facesService.get()
    $scope.set = set
    $scope.isSelected = isSelected
    $scope.fbfgDialog = fbfgDialog

    init()

    function init() {
      if ($scope.element.promotions.fbfg && pushedToday()) {
        delete $scope.element.promotions.fbfg
      }
    }

    function set(mood, isUnauth) {
      if (
        !isUnauth &&
        !userService.loggedIn() &&
        $scope.element.promotions.fbfg
      ) {
        return userService
          .promptLogin(
            'Charity donations only count when you are logged in. Signing up is free and only takes 10 seconds!'
          )
          .then(
            function() {
              set(mood)
            },
            function() {
              delete $scope.element.promotions.fbfg
              set(mood)
            }
          )
      }
      if (!pushedToday() && userService.loggedIn()) {
        prefs.set(pushedKey, true, { expiry: '24 hours' })
      }
      restartTimer()
      if ($scope.model === mood.value) {
        if ($scope.doubleTap) {
          $scope.doubleTap()
          glAnalytics.track('Faces', 'doubletap-face', mood.value)
        }
      } else {
        $scope.model = mood.value
        sendResponse(mood)
        glAnalytics.track('Faces', 'tap-face', mood.value)
      }
    }

    function pushedToday() {
      return prefs.get(pushedKey) === true
    }

    function isSelected(mood) {
      return mood.value === $scope.model
    }

    function sendResponse(mood) {
      // if (!userService.loggedIn() && pushedToday()) {
      //     return;
      // }
      var response = []
      var survey = _.find($scope.element.surveys, {
        id: $scope.element.extras.quickSurvey,
      })
      _.each(survey.questions, function(question, index) {
        response[index] = {
          choiceAnswers: [],
          questionId: question.id,
          textAnswer: question.type === 'mood' ? mood.value : '',
        }
      })
      surveysService.respond($scope.element.extras.quickSurvey, response).then(
        function() {
          log.info('mood survey response sent')
        },
        function() {
          log.error('mood survey response error')
        }
      )
    }

    function restartTimer() {
      $timeout.cancel(timer)
      timer = $timeout(resetMood, POPBACK_TIME_SECONDS * 1000)
    }

    function resetMood() {
      $scope.model = null
      if ($scope.element.promotions.fbfg) {
        delete $scope.element.promotions.fbfg
      }
    }

    function fbfgDialog() {
      glDialog.show({
        templateUrl: 'faces-dialog-fbfg.template.html',
        controller: function() {},
      })
      glAnalytics.track('Faces', 'tap-learn-more')
    }
  }
})()
